<template>
<div>
  MyPageWorkManager
</div>
</template>

<script>
export default {
  name: 'MyPageWorkManager'
}
</script>

<style scoped>

</style>
